import { useState, useEffect } from "react";
import FormField from "components/FormField";
import styles from "./BlacklistForm.module.scss";

const ContactSearchField = ({
  contacts,
  loading,
  onSearch,
  onSelect,
  selectedContact,
  onClear,
  error
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    if (selectedContact) {
      setSearchQuery(selectedContact.name || selectedContact.email || "");
      setShowDropdown(false);
    }
  }, [selectedContact]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (onSearch) onSearch(searchQuery);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    setShowDropdown(query.length > 0 && !selectedContact);

    // Clear selection if user is typing and it doesn't match selected contact
    if (selectedContact && query !== selectedContact.name && query !== selectedContact.email) {
      onClear();
    }
  };

  const handleContactSelect = (contact) => {
    onSelect(contact);
    setShowDropdown(false);
  };

  const handleClearSelection = () => {
    setSearchQuery("");
    setShowDropdown(false);
    onClear();
  };

  const filteredContacts = contacts?.data ? contacts.data.filter(contact =>
    !selectedContact ||
    contact.id === selectedContact.id ||
    (searchQuery && (
      (contact.name && contact.name.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (contact.email && contact.email.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (contact.phone && contact.phone.toLowerCase().includes(searchQuery.toLowerCase()))
    ))
  ) : [];

  return (
    <div className={styles.contactSearchField}>
      <FormField
        type="text"
        fieldName="contactSearch"
        labelText="Select Contact"
        placeholderText="Search by name, email, or phone..."
        value={searchQuery}
        onChange={handleSearchChange}
        error={error}
        style="form"
      />
      
      {showDropdown && (
        <div className={styles.contactDropdown}>
          {loading ? (
            <div className={styles.dropdownLoading}>Searching...</div>
          ) : filteredContacts.length > 0 ? (
            filteredContacts.slice(0, 10).map(contact => (
              <button
                key={contact.id}
                className={styles.contactItem}
                onClick={() => handleContactSelect(contact)}
                type="button"
              >
                <div className={styles.contactName}>{contact.name}</div>
                {contact.email && <div className={styles.contactEmail}>{contact.email}</div>}
                {contact.phone && <div className={styles.contactPhone}>{contact.phone}</div>}
                {contact.customer_name && (
                  <div className={styles.contactCustomer}>{contact.customer_name}</div>
                )}
              </button>
            ))
          ) : (
            <div className={styles.noResults}>No contacts found</div>
          )}
        </div>
      )}

      {selectedContact && (
        <div className={styles.selectedContact}>
          <div className={styles.selectedContactInfo}>
            <div className={styles.contactName}>{selectedContact.name}</div>
            {selectedContact.email && <div className={styles.contactEmail}>{selectedContact.email}</div>}
            {selectedContact.phone && <div className={styles.contactPhone}>{selectedContact.phone}</div>}
            {selectedContact.customer_name && (
              <div className={styles.contactCustomer}>{selectedContact.customer_name}</div>
            )}
          </div>
          <button
            className={styles.clearSelection}
            onClick={handleClearSelection}
            type="button"
          >
            Clear
          </button>
        </div>
      )}
    </div>
  );
};

export default ContactSearchField;